import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import UserRepository from '../../data/repository/UserRepository';

const ActivateUserAccount = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');
  const uid = queryParams.get('uid');

  const repository = new UserRepository();

  useEffect(() => {
    repository.activateAccount(token, uid).then((response) => {
      navigate('/', {
        state: {
          showMessage: true,
          message: response.success ? response.data.message : response.message
        }
      });
    });
  }, [uid, token, navigate, repository]);

  return null;
};

export default ActivateUserAccount;
